/* jslint browser: true */

import './util/polyfills';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { Provider } from 'react-redux';
import Cookie from 'js-cookie';
import { init } from '@sentry/react';
import { setAuthToken, setApiUrl, setResourcesUrl } from './apis/allevi-api-wrapper';

// import App from './App_MAINTENANCE'; // TEMP for maintenance
import App from './App'; // Normal routes
import * as serviceWorker from './serviceWorker';

import Store from './state/redux/store';

if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_MOCK_API === 'true') {
  const { worker } = module.require('./mocks/browser');

  worker.start();
}

const StoreInstance = Store();
const rootEl = document.getElementById('root');

//  Set auth token from cookie, if exists
if (Cookie.get('allevi-session-token')) {
  const token = Cookie.get('allevi-session-token');
  sessionStorage.setItem('id_token', token);
  setAuthToken(token);
}

let apiUrl = process.env.REACT_APP_API_URL;
let resourcesUrl = process.env.REACT_APP_RESOURCES_URL;
if (!apiUrl) throw new Error('No api url configured!');
if (!resourcesUrl) throw new Error('No resources url configured!');

if (process.env.REACT_APP_HOST_ENVIRONMENT === 'ON_PREM') {
  if (!window.couchDBConfig) {
    if (process.env.REACT_APP_CLIENT_USER && process.env.REACT_APP_CLIENT_SECRET) {
      const envvar = require('envvar');
      const clientUser = envvar.string('REACT_APP_CLIENT_USER', '');
      const clientSecret = envvar.string('REACT_APP_CLIENT_SECRET', '');
      const url = `https://${clientUser}:${clientSecret}@couchdb.allevi.software:6984`;

      window.couchDBConfig = { url };
    }
  }

  window.hostEnvironment = process.env.REACT_APP_HOST_ENVIRONMENT;

  // Set API URL for on-prem platform
  apiUrl = 'https://api.allevi.software:8000';
}

setApiUrl(apiUrl);
setResourcesUrl(resourcesUrl);

ReactDOM.render(
  <Provider store={StoreInstance}>
    <App />
  </Provider>,
  rootEl
);

if (process.env.REACT_APP_HOST_ENVIRONMENT === 'CLOUD') {
  init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    enabled: process.env.NODE_ENV === 'production',
    allowUrls: [
      /bioprint\.allevi3d\.com/,
      /bioprint-beta\.allevi\.app/,
      /bioprint-beta-2\.allevi\.app/,
      /beta-dev\.allevi\.app/
    ],
    ignoreErrors: ['Non-Error promise rejection captured'],
    environment: window.location.host
  });
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
